import { AlertType } from '~/types';
import { HeaderSortOptions } from '~/types/misc';
import { FEMUR_COMMENTS_COL, FEMUR_FLIGHT_DOWN_COL, FEMUR_FLIGHT_UP_COL, IODINATION_DUE_DATE_COL, SERIAL_COL, STANDARD_PLUS_GEN_STATUS } from '../genericTableColumns';
import { addAttributeDateDisplays, addBaseProperties, addFemurComments, addGenericStatus, addIodinateDueDate, addLaunchReturn, addStatusDateDisplays } from '../mappers';
import { buildIconAsString } from '../ui/buildIconAsString';
import { CosmicIcons } from '../ui/CosmicIcons';
import { ACTIVITY_TABLE_HEADERS } from './activities';
export const EMU_WATER_PROCESSING_JUMPER_TABLE_HEADERS = [
    ...STANDARD_PLUS_GEN_STATUS,
    IODINATION_DUE_DATE_COL
];
export const FEMUR_EMU_WATER_PROCESSING_JUMPER_TABLE_HEADERS = [
    SERIAL_COL,
    {
        text: 'Iodination<br/>Actual Iodinate<br/><small>(every 180d)</small>',
        value: '_lastIodinateDate',
        sortable: true,
        noWrap: true,
        noEscape: true,
        headerSortType: HeaderSortOptions.DATE
    },
    {
        text: 'Iodination due<br/><small>(every 180d)</small>',
        value: '_iodinateDueDate',
        sortable: true,
        noWrap: true,
        noEscape: true,
        headerSortType: HeaderSortOptions.DATE
    },
    FEMUR_FLIGHT_UP_COL,
    FEMUR_FLIGHT_DOWN_COL,
    FEMUR_COMMENTS_COL
];
export const ACTIVITY_EMU_WATER_PROCESSING_JUMPER_TABLE_HEADERS = [...ACTIVITY_TABLE_HEADERS];
export const transformEmuWaterProcessingJumper = (items) => {
    return items
        .map(addAttributeDateDisplays)
        .map(addBaseProperties)
        .map(addStatusDateDisplays)
        .map(addIodinateDueDate)
        .map(addFemurComments)
        .map(addGenericStatus)
        .map(addLaunchReturn)
        .map((item) => {
        const status = item.status;
        const isWetted = Boolean(status.lastIodinateDate?.value);
        // adding row class based on iodinateDueDate
        const rowClass = item.status?.iodinateDueDate?.alertType === AlertType.ALERT
            ? 'red lighten-3'
            : item.status?.iodinateDueDate?.alertType === AlertType.WARNING
                ? 'orange lighten-3'
                : '';
        const _item = Object.assign({}, item, {
            rowClass,
            _statusIcon: buildIconAsString({
                iconClass: isWetted
                    ? `${CosmicIcons['WETTED']} text--darken-2`
                    : `${CosmicIcons['NON_WETTED']} text--darken-2`,
                color: isWetted ? 'success' : 'error',
                title: `${isWetted ? 'Wetted' : 'Dry'}`
            })
        });
        return _item;
    });
};
